/**
 * @generated SignedSource<<8b19f8be9bf060e32538aa5c6afc4ed5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainToolbar_todo$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarEdit_todo">;
  readonly " $fragmentType": "TodoEditNewMainToolbar_todo";
};
export type TodoEditNewMainToolbar_todo$key = {
  readonly " $data"?: TodoEditNewMainToolbar_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainToolbar_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainToolbar_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoToolbarEdit_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "7d306c7fed2b00d6276f632a39179f68";

export default node;
